import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { loginPathWithRedirect } from "@lib/authentication/loginRedirect";
import { useAuthContext } from "@lib/contexts/AuthenticationContext";

type RequireAuthProps = {
  children: ReactNode;
};

export const RequireAuth = ({ children }: RequireAuthProps) => {
  const { isAuthenticated } = useAuthContext();
  const location = useLocation();

  if (!isAuthenticated) {
    // Carry the attempted location so login can return the user to it
    // instead of dropping them on /home (OMG-2449).
    return <Navigate to={loginPathWithRedirect(location)} replace />;
  }

  return children;
};
